<template>
  <el-table-column
    prop="status"
    sortable="custom"
    label="Státusz"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.status === 'recorded'" size="small" type="info">Rögzítve</el-tag>
      <el-tag v-if="scope.row.status === 'sent'" size="small" type="primary">Összekészítésre vár</el-tag>
      <el-tag v-if="scope.row.status === 'partly-done'" size="small" type="warning">Részben teljesítve</el-tag>
      <el-tag v-if="scope.row.status === 'done'" size="small" type="success">Teljesítve</el-tag>
      <el-tag v-if="scope.row.status === 'resigned'" size="small" type="danger">Lemondva</el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'status',
};
</script>
